import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RaygunService {
  constructor(@Inject(DOCUMENT) readonly document: Document,
    private readonly appConfigService: AppConfigService) {
  }

  public apply(): void {
    const config = this.appConfigService.getConfig();

    if (config.raygunApiKey) {
      const libraryScript = this.createLibraryScript(this.document);
      const script = this.createScript(this.document, config.raygunApiKey);

      this.document.head.appendChild(libraryScript);
      this.document.head.appendChild(script);
    }
  }

  private createLibraryScript(document: Document): HTMLScriptElement {
    const element = document.createElement('script');
    element.innerHTML = `!function(a,b,c,d,e,f,g,h){a.RaygunObject=e,a[e]=a[e]||function(){
      (a[e].o=a[e].o||[]).push(arguments)},f=b.createElement(c),g=b.getElementsByTagName(c)[0],
      f.async=1,f.src=d,g.parentNode.insertBefore(f,g),h=a.onerror,a.onerror=function(b,c,d,f,g){
      h&&h(b,c,d,f,g),g||(g=new Error(b)),a[e].q=a[e].q||[],a[e].q.push({
      e:g})}}(window,document,"script","//cdn.raygun.io/raygun4js/raygun.min.js","rg4js");`;

    return element;
  }

  private createScript(document: Document, key: string): HTMLScriptElement {
    const element = document.createElement('script');
    element.innerHTML = `rg4js('apiKey', '${key}');
          rg4js('enableCrashReporting', true);
          rg4js('withTags', 'angular');`;

    return element;
  }
}
